import React, { FC } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { AccountType } from "@green0meter/api-client";

import { CompanyEditorFieldWithCreateModeProps } from "../../CompanyEditor.types";
import { accountTypeColors } from "../../CompanyEditor.constants";

import { TextField, Typography, Chip, Autocomplete } from "@components/base";

const AccountTypeField: FC<CompanyEditorFieldWithCreateModeProps> = ({
  control,
  isCreateMode,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="body2" color="text.secondary">
        {t("admin.accountType")}
        {isCreateMode && " *"}
      </Typography>
      <Controller
        name="accountType"
        control={control}
        rules={{ required: isCreateMode }}
        render={({ field, fieldState: { error } }) => (
          <Autocomplete
            options={[AccountType.Real, AccountType.Test, AccountType.Demo]}
            getOptionLabel={(option) => AccountType[option]}
            value={field.value ?? AccountType.Real}
            onChange={(_event, newValue) => {
              if (newValue !== null) field.onChange(newValue);
            }}
            isOptionEqualToValue={(option, value) => option === value}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="filled"
                placeholder={t("admin.accountType")}
                error={!!error}
              />
            )}
            renderOption={(props, option) => (
              <li {...props}>
                <Chip
                  label={AccountType[option]}
                  color={accountTypeColors[option]}
                  size="small"
                  sx={{ mr: 1 }}
                />
                {AccountType[option]}
              </li>
            )}
          />
        )}
      />
    </>
  );
};

export default AccountTypeField;
